import { Component } from '@angular/core';

import { environment } from '../../environments/environment';
import { AppLauncherStateService } from '../app-launcher-state.service';

interface LandingAnchor {
	id: string;
	label: string;
}

@Component({
	selector: 'sd-header',
	templateUrl: './header.component.html',
})
export class HeaderComponent {
	public readonly anchors: LandingAnchor[] = [
		{ id: 'how-it-works', label: 'How It Works' },
		{ id: 'why-app-deployment', label: 'Why App Launcher' },
		{ id: 'product-screens', label: 'Deployment Path' },
		{ id: 'free-preview', label: 'Get Started' },
	];

	constructor(public readonly state: AppLauncherStateService) {}

	public goLanding(): void {
		const url = (environment.labsLandingUrl || '').trim();
		if (url && !this.state.authenticated) {
			window.location.href = url;
			return;
		}
		this.state.goTo('landing');
	}

	public signIn(): void {
		this.state.setAccountMode('sign-in');
		this.state.goTo('login');
	}

	public async logout(): Promise<void> {
		await this.state.logout();
	}

	public scrollToAnchor(id: string): void {
		const scroll = () =>
			document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
		if (this.state.step !== 'landing') {
			this.state.goTo('landing');
			requestAnimationFrame(scroll);
		} else {
			scroll();
		}
	}
}
